module.exports = __webpack_public_path__ + "static/media/ic_bank.09c0f61e.png";